import { Divider, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface SidebarSectionProps {
  title: string;
  children?: ReactNode;
}
const SidebarSection = ({ title, children }: SidebarSectionProps) => {
  return (
    <Stack pt={2}>
      <Typography
        component="small"
        fontSize=".875em"
        fontWeight={"bold"}
        mb={1}
      >
        {title}
      </Typography>

      {children}

      <Divider
        sx={{
          opacity: 1,
          backgroundColor: "primary.contrastText",
          marginTop: 3,
        }}
      />
    </Stack>
  );
};
export default SidebarSection;
